import { Injectable } from '@angular/core';

@Injectable()
export class GenericListModalService {
    public displayed: boolean = false;
    public title: string = '';
    public restName: string = '';
    public href: string = '';
    public filter: any = '';
    public listFilter: string = '';
    public glyph: string = '';
    public templateNameRecord: string = '';
    public infinite: boolean = false;
    public showCreate: boolean = true;
    public close: Function;
}